import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { docs, categoryOrder } from '../../docs';
import styles from './Sidebar.module.scss';

function Sidebar({ sidebarHeight }) {
    const navigate = useNavigate();
    const { slug } = useParams();

    const groupedDocs = useMemo(() => {
        const groups = docs.reduce((acc, doc) => {
            if (!acc[doc.category]) acc[doc.category] = [];
            acc[doc.category].push(doc);
            return acc;
        }, {});
        return groups;
    }, []);

    const toSlug = (str) =>
        str.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');

    return (
        <aside style={{ height: sidebarHeight }} className={`${styles.sidebar} desktop-only`}>
            <nav>
                {categoryOrder.map(category => {
                    const items = groupedDocs[category] || [];
                    if (items.length === 0) return null;
                    return (
                        <div key={category} className={styles.group}>
                            <h4 className={styles.groupTitle}>
                                &#x21db; {category.charAt(0).toUpperCase() + category.slice(1)}
                            </h4>
                            <ul>
                                {items.map((doc) => {
                                    const isActive = doc.id === slug;
                                    return (
                                        <li
                                            key={doc.id}
                                            onClick={() => navigate(`/docs/${toSlug(doc.id)}`)}
                                            className={`${styles.link} ${isActive ? styles.active : ''}`}
                                        >
                                            {doc.title}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    );
                })}
            </nav>
        </aside>
    );
}

export default Sidebar;